/* NØRZ 2026-10-14 · Calculadora de envío (pop-up país + código postal).
   Se abre desde el tercer mensaje rotativo de «Estimación de entrega» (PDP).
   - Carrito con productos: tarifas reales de Shopify (/cart/prepare_shipping_rates.json
     + /cart/async_shipping_rates.json).
   - Carrito vacío (o si la API falla): tabla de respaldo de Ajustes del tema
     (shipping_calc_rates), indicada como estimación. */
(function () {
  if (window.sannaShipCalcLoaded) return;
  window.sannaShipCalcLoaded = true;

  var dlg = null, cfg = null, el = {};

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(v) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: cfg.currency || 'EUR' }).format(v);
    } catch (e) {
      return Number(v).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function readCfg(trigger) {
    var wrap = trigger.closest('[data-spd-calc]');
    var tag = wrap && wrap.querySelector('[data-spd-calc-config]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function build() {
    var t = cfg.i18n;
    var opts = cfg.countries.map(function (c) {
      return '<option value="' + esc(c.c) + '"' + (c.c === cfg.country ? ' selected' : '') + '>' + esc(c.n) + '</option>';
    }).join('');
    dlg = document.createElement('dialog');
    dlg.className = 'sanna-calc';
    dlg.setAttribute('aria-labelledby', 'sanna-calc-title');
    dlg.innerHTML =
      '<button type="button" class="sanna-calc__close" aria-label="' + esc(t.close) + '">&times;</button>' +
      '<h2 class="sanna-calc__title" id="sanna-calc-title">' + esc(t.title) + '</h2>' +
      '<p class="sanna-calc__intro">' + esc(t.intro) + '</p>' +
      '<form class="sanna-calc__form" novalidate>' +
        '<label class="sanna-calc__field"><span>' + esc(t.country) + '</span><select name="country">' + opts + '</select></label>' +
        '<label class="sanna-calc__field"><span>' + esc(t.zip) + '</span><input name="zip" type="text" autocomplete="postal-code" inputmode="text" maxlength="12"></label>' +
        '<button type="submit" class="button button--regular button--solid button--fullwidth sanna-calc__submit">' + esc(t.submit) + '</button>' +
      '</form>' +
      '<div class="sanna-calc__result" aria-live="polite"></div>' +
      '<p class="sanna-calc__note">' + esc(t.freeOver) + '</p>';
    document.body.appendChild(dlg);
    el.form = dlg.querySelector('form');
    el.zip = dlg.querySelector('[name="zip"]');
    el.country = dlg.querySelector('[name="country"]');
    el.result = dlg.querySelector('.sanna-calc__result');
    el.submit = dlg.querySelector('.sanna-calc__submit');

    dlg.querySelector('.sanna-calc__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    el.form.addEventListener('submit', onSubmit);
  }

  function showMsg(text, isError) {
    el.result.innerHTML = '<p class="sanna-calc__msg' + (isError ? ' is-error' : '') + '">' + esc(text) + '</p>';
  }

  function showRates(list, isEstimate) {
    var t = cfg.i18n;
    var html = '<ul class="sanna-calc__rates">' + list.map(function (r) {
      var price = r.price > 0 ? money(r.price) : t.free;
      return '<li><span class="sanna-calc__rate-name">' + esc(r.name) +
        (r.note ? '<small>' + esc(r.note) + '</small>' : '') +
        '</span><strong>' + esc(price) + '</strong></li>';
    }).join('') + '</ul>';
    if (isEstimate) html += '<p class="sanna-calc__estimate">' + esc(t.estimate) + '</p>';
    el.result.innerHTML = html;
  }

  function query(country, zip) {
    return 'shipping_address[zip]=' + encodeURIComponent(zip) +
      '&shipping_address[country]=' + encodeURIComponent(country) +
      '&shipping_address[province]=';
  }

  function poll(q, n) {
    return fetch('/cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (r.status === 202 && n < 12) {
        return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return poll(q, n + 1); });
      }
      if (!r.ok) throw new Error('rates');
      return r.json().then(function (j) { return j.shipping_rates || []; });
    });
  }

  function realRates(country, zip) {
    var q = query(country, zip);
    return fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('prepare');
        return poll(q, 0);
      })
      .then(function (rates) {
        return rates.map(function (r) {
          return { name: r.presentment_name || r.name, price: parseFloat(r.price) || 0, note: '' };
        });
      });
  }

  function fallbackRates(country, totalCents) {
    var exact = [], any = [];
    String(cfg.rates || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      if (p.length < 3) return;
      var price = parseFloat(String(p[2]).replace(',', '.'));
      if (isNaN(price)) return;
      var o = { name: p[1], price: price, note: p[3] || '' };
      if (p[0].toUpperCase() === country) exact.push(o);
      else if (p[0] === '*') any.push(o);
    });
    var list = exact.length ? exact : any;
    if (list.length && cfg.thresholdCents > 0 && totalCents >= cfg.thresholdCents) {
      list[0] = { name: list[0].name, price: 0, note: list[0].note };
    }
    return list;
  }

  function onSubmit(e) {
    e.preventDefault();
    var t = cfg.i18n;
    var zip = el.zip.value.trim();
    var country = el.country.value;
    if (!zip) { showMsg(t.zipRequired, true); el.zip.focus(); return; }
    el.submit.disabled = true;
    showMsg(t.loading, false);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        if (cart.item_count > 0) {
          return realRates(country, zip).then(function (rates) {
            if (!rates.length) { showMsg(t.noRates, true); return; }
            showRates(rates, false);
          }).catch(function () {
            var fb = fallbackRates(country, total);
            if (fb.length) showRates(fb, true); else showMsg(t.error, true);
          });
        }
        var fb = fallbackRates(country, total);
        if (fb.length) showRates(fb, true); else showMsg(t.noRates, true);
      })
      .catch(function () { showMsg(t.error, true); })
      .then(function () { el.submit.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-spd-calc-open]');
    if (!trigger) return;
    e.preventDefault();
    var c = readCfg(trigger);
    if (!c) return;
    if (!dlg) { cfg = c; build(); }
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    setTimeout(function () { el.zip.focus(); }, 30);
  });
})();
